import {ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const PageGoBack = function ( props:{
    onClick?: () => void
}) {

    return (
        <div className="mig-back" style={{ padding: "0.1em 0.1em 0.1em 1em", marginBottom:"-1em", textAlign: "left"}} onClick={props.onClick}>
            <Button type="link" style={{color:"black"}}><ArrowLeftOutlined />Atrás</Button>
        </div>
    )

}